import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import tinymce from 'vue-tinymce-editor'
import VueBootstrapToasts from "vue-bootstrap-toasts";
import excel from 'vue-excel-export'
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import Echo from "@/plugins/echo"

const TOAST_DEFAULTS = {
  success: {
    timeOut: 3000,
    closeable: true,
    showProgress: true,
  },
  warning: {
    timeOut: 6000,
    closeable: true,
    showProgress: true,
  },
  info: {
    timeOut: 4500,
    closeable: true,
    showProgress: true,
  },
  danger: {
    timeOut: 9000,
    closeable: true,
    showProgress: true,
  },
}

Vue.prototype.$echo = Echo
Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(excel)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(VueBootstrapToasts);
const baseToast = Vue.prototype.$toast
Vue.prototype.$toast = {
  ...baseToast,
  send(message, type, options = {}) {
    const defaults = TOAST_DEFAULTS[type] || {}
    const {
      notificationCenter = null,
      recordInCenter = ["warning", "danger"].includes(type),
      ...toastOptions
    } = options

    if (recordInCenter) {
      const centerData = notificationCenter || {}
      const timestamp = new Date().toISOString()
      store.dispatch("notificationCenter/addNotification", {
        id: `${timestamp}-${Math.random().toString(36).slice(2, 9)}`,
        type,
        message,
        title: centerData.title || null,
        details: Array.isArray(centerData.details) ? centerData.details.filter(Boolean) : [],
        productName: centerData.productName || null,
        batchNumber: centerData.batchNumber || null,
        route: router.currentRoute?.fullPath || "",
        read: false,
        createdAt: timestamp,
      })
    }

    return baseToast.send(message, type, {
      ...defaults,
      ...toastOptions,
    })
  },
  success(message, options = {}) {
    return this.send(message, "success", options)
  },
  warning(message, options = {}) {
    return this.send(message, "warning", options)
  },
  info(message, options = {}) {
    return this.send(message, "info", options)
  },
  error(message, options = {}) {
    return this.send(message, "danger", options)
  },
}
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
